import React from 'react';
import { Modal as BaseModal, Divider } from 'semantic-ui-react';
import log from 'loglevel';

import { Box, Flex, Text, Link, Button } from 'src/Components/Base';
import MyDepartments from 'src/Containers/MyDepartments';
import styled from 'styled-components';
import { SPACE } from 'src/Components/Theme';

const Modal = styled(BaseModal)`
  width: 100%;
  max-width: 480px;
`;

export const ChooseDepartmentModal = ({
  open,
  onClose,
  onSelectDepartmentId = () => {},
  onClickSelectFromNonFav,
}) => {
  const handleSelect = id => {
    log.debug('ChooseDepartmentModal', id);
    onSelectDepartmentId(id);
  };
  const handleClickNonFav = e => {
    onClose();
    onClickSelectFromNonFav();
  };
  return (
    <Modal dimmer="inverted" size="tiny" open={open} onClose={onClose}>
      <Modal.Header>เลือกคณะที่สอบติด</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <MyDepartments
            variant="select-mode"
            onClick={handleSelect}
            onSelectDepartmentId={handleSelect}
          />
          <Divider />
          <Box py={SPACE.small}>
            <Button primary basic fluid circular onClick={handleClickNonFav}>
              ติดคณะที่ไม่ได้อยู่ในคณะในดวงใจ
            </Button>
          </Box>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default ChooseDepartmentModal;
